import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your translation files
import enTranslations from "./locales/en.json";
import esTranslations from "./locales/es.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enTranslations },
            es: { translation: esTranslations },
        },
        lng: "en", // Set default language
        fallbackLng: "en", // Fallback language if translation is missing
        interpolation: {
            escapeValue: false, // React already safes from XSS
        },
    });

export default i18n;
